import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LuFipsAppResource from "./LuFipsAppResource";

class ModelRecordAppResouce extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'fa-model-record';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'models/records';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'fips',
            'propertyId',
            'apn',
            'situsFullStreetAddress',
            'situsHouseNbr',
            'situsHouseNbrSuffix',
            'situsDirectionLeft',
            'situsStreet',
            'situsMode',
            'situsDirectionRight',
            'situsUnitType',
            'situsUnitNbr',
            'situsCity',
            'situsState',
            'situsZip5',
            'situsZip4',
            'situsCarrierCode',
            'finalValue',
            'highValue',
            'lowValue',
            'confidenceScore',
            'standardDeviation',
            'valuationDate',
            'valuationModel',
            'meta',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            luFips: LuFipsAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            luFips: 'fips',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {};
    }

}

export default ModelRecordAppResouce;
